import createAttachmentsApi from './provider';

const PROJECT_ITEM_ATTACHMENT_TYPE_ID = 1;

const { get, add, edit, remove } = createAttachmentsApi(PROJECT_ITEM_ATTACHMENT_TYPE_ID);
export { get, add, edit, remove };